var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-card",
        {
          staticClass: "md-card q-mt-lg q-pa-lg relative-position",
          attrs: { color: "white", "text-color": "black" }
        },
        [
          _c("q-card-title", [
            _c("h4", [
              _vm._v("End-User License Agreement (EULA) of "),
              _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")])
            ])
          ]),
          _c("q-card-separator"),
          _c("q-card-main", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 l-lg-pad r-lg-pad" }, [
                _c("p", [
                  _vm._v(
                    'This End-User License Agreement ("EULA") is a legal agreement between you and '
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v(
                      "Associated General Contractors of Minnesota (AGC-MN)"
                    )
                  ])
                ]),
                _c("p", [
                  _vm._v(
                    "This EULA agreement governs your acquisition and use of our "
                  ),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(' software\n            ("Software") directly from '),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(" or indirectly through a\n            "),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    ' authorized reseller\n            or distributor (a "Reseller").'
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "Please read this EULA agreement carefully before completing the installation process and using the "
                  ),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(" software. It provides a license to use the "),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(
                    " software and contains warranty information and liability disclaimers."
                  )
                ]),
                _c("p", [
                  _vm._v("If you register for a free trial of the "),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(
                    ' software, this EULA\n            agreement will also govern that trial. By clicking "accept" or installing and/or using the '
                  ),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(
                    " software, you are confirming your acceptance of the Software and agreeing\n            to become bound by the terms of this EULA agreement."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent\n            that you have the authority to bind such entity and its affiliates to these terms and conditions. If you\n            do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do\n            not install or use the Software, and you must not accept this EULA agreement."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "This EULA agreement shall apply only to the Software supplied by "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    "\n            herewith regardless of whether other software is referred to or described herein. The terms also apply to\n            any "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " updates,\n            supplements, Internet-based services, and support services for the Software, unless other terms accompany\n            those items on delivery. If so, those terms apply."
                  )
                ]),
                _c("h5", [_vm._v("License Grant")]),
                _c("p", [
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " hereby grants you\n            a personal, non-transferable, non-exclusive licence to use the "
                  ),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(
                    "\n            software on your devices in accordance with the terms of this EULA agreement."
                  )
                ]),
                _c("p", [
                  _vm._v("You are permitted to load the "),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(
                    " software (for example a PC, laptop,\n            mobile or tablet) under your control. You are responsible for ensuring your device meets the minimum\n            requirements of the "
                  ),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(" software.")
                ]),
                _c("p", [_vm._v("You are not permitted to:")]),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor\n              permit the whole or any part of the Software to be combined with or become incorporated in any other\n              software, nor decompile, disassemble or reverse engineer the Software or attempt to do any such things\n            "
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Reproduce, copy, distribute, resell or otherwise use the Software for any commercial purpose"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Allow any third party to use the Software on behalf of or for the benefit of any third party"
                    )
                  ]),
                  _c("li", [
                    _vm._v(
                      "Use the Software in any way which breaches any applicable local, national or international law"
                    )
                  ]),
                  _c("li", [
                    _vm._v("Use the Software for any purpose that "),
                    _c("span", { staticClass: "company_name" }, [
                      _vm._v("AGC-MN")
                    ]),
                    _vm._v(
                      "\n              considers is a breach of this EULA agreement\n            "
                    )
                  ])
                ]),
                _c("h5", [_vm._v("Intellectual Property and Ownership")]),
                _c("p", [
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " shall at all times\n            retain ownership of the Software as originally downloaded by you and all subsequent downloads of the\n            Software by you. The Software (and the copyright, and other intellectual property rights of whatever\n            nature in the Software, including any modifications made thereto) are and shall remain the property of\n            "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(".")
                ]),
                _c("p", [
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " reserves the right\n            to grant licences to use the Software to third parties."
                  )
                ]),
                _c("h5", [_vm._v("Termination")]),
                _c("p", [
                  _vm._v(
                    "This EULA agreement is effective from the date you first use the Software and shall continue until\n            terminated. You may terminate it at any time upon written notice to "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(".\n          ")
                ]),
                _c("p", [
                  _vm._v(
                    "It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such\n            termination, the licenses granted by this EULA agreement will immediately terminate and you agree to stop\n            all access and use of the Software. The provisions that by their nature continue and survive will survive\n            any termination of this EULA agreement."
                  )
                ]),
                _c("h5", [_vm._v("General Terms and Conditions")]),
                _c("p", [
                  _vm._v("You agree that use of the "),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(" is at your sole risk. "),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(
                    " app is provided as an “as is” and “as\n            available” basis. You agree that use of the Service, including any applets, software, content and services\n            accessible therein, is entirely at your own risk."
                  )
                ]),
                _c("p", [
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " does not warrant that the service is free from bugs, viruses,\n            errors, or other\n            program limitations, nor does "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " warrant access to the Internet or\n            to any other service\n            or content through "
                  ),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(".")
                ]),
                _c("p", [
                  _vm._v("The entire liability of "),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " for any reason\n            shall be limited to the amount paid by the customer for the related services or content purchased from\n            "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(", its authorized reseller or its service providers.")
                ]),
                _c("p", [
                  _vm._v("To the maximum extent permitted by applicable law, "),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " and its\n            subsidiaries, affiliates,\n            licensors, participating financial institutes, third-party content or service providers, distributors,\n            dealers or suppliers (“Representatives”) are not liable for any indirect, special, incidental, or\n            consequential damages (including, but not limited to, damages for loss of business, loss of profits or\n            investment, or the like), whether based on breach of warranty, tort (including negligence), product\n            liability or otherwise, even if "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " or its representatives have been\n            advised of the\n            possibility of such damages, and even if a remedy set forth herein is found to have failed of its\n            essential purpose."
                  )
                ]),
                _c("p", [
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    "’ total liability related to or arising out of this agreement\n            shall be limited to the\n            amount of fees actually paid by you to "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " in the 12 months prior to\n            the event causing\n            any such liability."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "Some states do not allow the limitation and/or exclusion of liability for incidental or consequential\n            damages, so the above limitation or exclusion may not apply to you."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "The limitations of damages set forth above are fundamental elements of the basis of the bargain between\n            "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(" and you. "),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " would not be\n            able to have provided this Service to you\n            without such limitations."
                  )
                ]),
                _c("p", [
                  _vm._v("You agree that "),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " has the right to collect, store, and use\n            non-sensitive data that can\n            be uniquely identified to a particular account and otherwise sensitive data that will be anonymized and\n            aggregated."
                  )
                ]),
                _c("p", [
                  _vm._v("You agree that "),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " may use your name and logo to identify you as a\n            "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    "\n            customer on its website or in other sales or marketing materials (provided that "
                  ),
                  _c("span", { staticClass: "company_name" }, [
                    _vm._v("AGC-MN")
                  ]),
                  _vm._v(
                    " will\n            not issue any press release regarding your use of the "
                  ),
                  _c("span", { staticClass: "app_name" }, [_vm._v("AGC MN")]),
                  _vm._v(" without your\n            prior consent).")
                ]),
                _c("h5", [_vm._v("Governing Law")]),
                _c("p", [
                  _vm._v(
                    "This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be\n            governed by and construed in accordance with the laws of "
                  ),
                  _c("span", { staticClass: "country" }, [_vm._v("US")]),
                  _vm._v(".")
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }